import PropTypes from 'prop-types';
import React from 'react';

import ProgramIntakeClassStatus from '../../../../model/ProgramIntakeClassStatus';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';

const ProgramIntakeClassStatusSelector = props => {
  const t = useT();

  const { options } = useEnumerableModel(ProgramIntakeClassStatus);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={t('Class Status')}
      {...props}
    />
  );
};

ProgramIntakeClassStatusSelector.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOf(ProgramIntakeClassStatus.BasicProps)),
    PropTypes.string,
  ]),
  onChange: PropTypes.func,
};

ProgramIntakeClassStatusSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default ProgramIntakeClassStatusSelector;
